import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import { Controller, useForm } from 'react-hook-form';
import React, { useState } from 'react'
import { apiConnector } from '../../services/apiConnector';
import { authEndpoints } from '../../services/api';
import toast from 'react-hot-toast';

const { GET_ACCOUNT_DETAILS } = authEndpoints
const GetUserDetails = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [userDetails, setUserDetails] = useState(null);
    const { handleSubmit, setValue, control, formState: { errors } } = useForm({
        mode: 'all',
        defaultValues: {
            email: ''
        }
    });

    const onSubmit = async (data) => {
        const { email } = data
        // dispatch(deleteAccount(email))
        const response = await apiConnector("POST", GET_ACCOUNT_DETAILS, { email })
        // console.log(response.data)
        if (response.data.success) {
            setUserDetails(response.data.result);
        } else {
            toast.error(response.data.message || "Failed to fetch user details");
        }
        setValue('email', '')
    };
    return (
        <div className="flex dark:bg-dark font-primary h-screen overflow-hidden bg-[#fafafa]">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main>
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-y-4 mt-4">
                            <div className="flex flex-col gap-y-2">
                                <div className="flex items-center gap-x-4">
                                    <label className="text-gray-800 dark:text-zinc-300 text-[16px] font-medium">
                                        Email<span className="text-red-500">*</span>
                                    </label>
                                    {errors?.email && (
                                        <span className="text-red-500">{errors.email.message}</span>
                                    )}
                                </div>
                                <Controller
                                    name="email"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="email"
                                            className="form-input w-full"
                                            placeholder="Enter email"
                                        />
                                    )}
                                />
                            </div>
                            {/* Submit Button */}
                            <div className="mt-4">
                                <button type="submit" className="btn btn-primary">Submit</button>
                            </div>
                        </form>
                        {userDetails && (
                            <div className="mt-6">
                                <h2 className="text-xl font-semibold mb-4">User Details</h2>
                                <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md">
                                    <p><strong>Email:</strong> {userDetails.email}</p>
                                    <p><strong>Name:</strong> {userDetails.name}</p>
                                    <p><strong>Username:</strong> {userDetails.username}</p>
                                    {/* Add more fields as necessary */}
                                </div>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        </div>
    )
}

export default GetUserDetails